import { FC } from 'react';
import classNames from 'classnames';
import { CurrencyIcon, CurrencyEnum } from '@spectrocoin/sc-currencies';
import styles from './CurrencyField.module.scss';
import { formatPrecision } from '../../helpers/currencyHelper/currencyHelper';
import TextNode, { TextStyles } from '../TextNode/TextNode';

type CurrencyFieldProps = {
	className?: string;
	labelClassName?: string;
	iconClassName?: string;
	currencyName: string;
	currencyCode: CurrencyEnum;
	amount?: string;
	showLabel?: boolean;
};

const CurrencyField: FC<CurrencyFieldProps> = ({
	className,
	iconClassName,
	labelClassName,
	amount,
	currencyName,
	currencyCode,
	showLabel = true,
	...rest
}) => {
	return (
		<div className={classNames(styles.container, className)} {...rest}>
			<CurrencyIcon
				currencyType={currencyCode}
				className={classNames(styles.currencyIcon, iconClassName)}
			/>
			{(showLabel || amount) && (
				<TextNode
					className={classNames(styles.currencyLabel, labelClassName)}
					style={TextStyles.Ellipsis}
				>
					{showLabel && (
						<span className={styles.name}>{`${currencyName} ${currencyCode}`}</span>
					)}
					{amount && (
						<TextNode
							style={TextStyles.NoWrap | TextStyles.Ellipsis}
							className={styles.amount}
						>{`${formatPrecision(amount, currencyCode)} ${currencyCode}`}</TextNode>
					)}
				</TextNode>
			)}
		</div>
	);
};

export default CurrencyField;
